import React from 'react';
import { indicationsData, getCancerTypeIdFromIndicationId, createSubQIndicationListEntryByCancerType, subQIndicationsData } from './data';
import * as ISI from './styled';
import { createMarkup } from '../../util/functions';
import {IndicationsListContent} from './IndicationsList';

const QSubIndicationList = ({ columns = 1, scrollable_ref, indicationId }) => {
    //Because there will often be cases where we need to launch a 'standalone indication page' before the full content has been approved for global elements, we will pull content for 'singular indications' directly from the global array (rather than the list created in ./data.js).
    let indicationsListByCancerType = [];
    if (indicationId) {
        const cancerTypeId = getCancerTypeIdFromIndicationId(indicationId);
        indicationsListByCancerType = [createSubQIndicationListEntryByCancerType(cancerTypeId)];
    } else {
        indicationsListByCancerType = subQIndicationsData;
    }    

    return (
        <ISI.InformationListContainer ref={scrollable_ref}>
            {indicationsListByCancerType
                .filter(item => (indicationId) ? item.indicationIds.includes(indicationId) : item)
                .map((item, i) => {
                let indicationsContent = item.items
                .filter(indication => (!indication.isCombination || indication.showOnISI))
                .map((child, i) => child.statement);

                return (

                    <ISI.InformationItem columns={columns} key={i}>
                        <header>
                            <ISI.InformationItemLabel dangerouslySetInnerHTML={createMarkup(item.modifierAndName)} as='h3'>            
                            </ISI.InformationItemLabel>
                        </header>                        
                        <IndicationsListContent dangerouslySetInnerHTML={createMarkup(indicationsContent.join(''))} />
                    </ISI.InformationItem>
            )})}
        </ISI.InformationListContainer>
    );

    return null;
};

export default QSubIndicationList;

